import {SettingsType} from './SettingsStore.constants';
import {SettingsState} from './SettingsStore.types';

import {Store} from '@/stores/Store';

export class SettingsStore extends Store<SettingsState> {
  constructor() {
    super({
      remindersEnabled: false,
      musicEnabled: false,
      soundsEnabled: false,
      performanceModeEnabled: false,
      isPerformanceModeHidden: false,
    });
  }

  public setDefaultSettings = ({
    remindersEnabled,
    musicEnabled,
    soundsEnabled,
  }: Omit<SettingsState, 'performanceModeEnabled' | 'isPerformanceModeHidden'>): void => {
    this.setValue('remindersEnabled', remindersEnabled);
    this.setValue('musicEnabled', musicEnabled);
    this.setValue('soundsEnabled', soundsEnabled);
  };

  public setRemindersEnabled = (enabled: boolean): void => {
    this.setValue('remindersEnabled', enabled);
  };

  public setMusicEnabled = (enabled: boolean): void => {
    this.setValue('musicEnabled', enabled);
  };

  public setSoundsEnabled = (enabled: boolean): void => {
    this.setValue('soundsEnabled', enabled);
  };

  public setPerformanceModeEnabled = (enabled: boolean): void => {
    this.setValue('performanceModeEnabled', enabled);
  };

  public hidePerformanceMode(): void {
    this.setValue('isPerformanceModeHidden', true);
  }

  public isPerformanceModeHidden(): boolean {
    return this.state.isPerformanceModeHidden;
  }

  public getSettingValue = (settingType: SettingsType): boolean => {
    switch (settingType) {
      case SettingsType.Reminders:
        return this.state.remindersEnabled;
      case SettingsType.Music:
        return this.state.musicEnabled;
      case SettingsType.Sounds:
        return this.state.soundsEnabled;
      case SettingsType.PerformanceMode:
        return this.state.performanceModeEnabled;
    }
  };
}
